import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider } from '@backstage/theme';
import DarkIcon from '@material-ui/icons/Brightness2';
import { imdbDarkTheme } from './imdbTheme';

const ImdbDarkTheme = ThemeBlueprint.make({
  name: 'imdb-dark',
  params: {
    theme: {
      id: 'imdb-dark',
      title: 'IMDB Dark',
      variant: 'dark',
      icon: <DarkIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={imdbDarkTheme}>
          {children}
        </UnifiedThemeProvider>
      ),
    },
  },
});

export const themeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [ImdbDarkTheme],
});
